var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0117 5.04688H2.98828C1.33722 5.04688 0 6.3924 0 8.03516V25.9648C0 27.6174 1.34705 28.9531 2.98828 28.9531H31.0117C32.649 28.9531 34 27.623 34 25.9648V8.03516C34 6.39532 32.6681 5.04688 31.0117 5.04688ZM30.5932 7.03906C29.9827 7.64635 19.4758 18.0979 19.113 18.4587C18.5486 19.0232 17.7982 19.334 17 19.334C16.2018 19.334 15.4514 19.0231 14.8851 18.4569C14.6411 18.2142 4.2502 7.87804 3.40677 7.03906H30.5932ZM1.99219 25.5594V8.44189L10.601 17.0053L1.99219 25.5594ZM3.40804 26.9609L12.0134 18.4103L13.4783 19.8674C14.419 20.8081 15.6697 21.3262 17 21.3262C18.3303 21.3262 19.581 20.8081 20.5199 19.8693L21.9866 18.4103L30.592 26.9609H3.40804ZM32.0078 25.5594L23.399 17.0053L32.0078 8.44189V25.5594Z",
    fill: "#844C0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageicon);
export default __webpack_public_path__ + "static/media/messageicon.b805afac71e6efbb098d0ccf9e8379a6.svg";
export { ForwardRef as ReactComponent };